import { Component, inject } from '@angular/core';
import { ModalController, AlertController, IonicModule } from '@ionic/angular';
import { PushNotifications, DeliveredNotifications, PushNotificationSchema } from '@capacitor/push-notifications';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getPushNotificationItems } from 'src/app/ngrx/push-notification/push-notification.reducer';
import { AddPushNotification, ClearPushNotifications, RemovePushNotification } from 'src/app/ngrx/push-notification/push-notification.actions';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';
import { NoContentComponent } from '../../components/no-content/no-content.component';
import { AsyncPipe, DatePipe, LowerCasePipe } from '@angular/common';
import { AppState } from 'src/app/app.module';

@Component({
    selector: 'app-push-notification',
    templateUrl: './push-notification.page.html',
    styleUrls: ['./push-notification.page.scss'],
    imports: [IonicModule, NoContentComponent, AsyncPipe, DatePipe, TranslatePipe, LowerCasePipe]
})
export class PushNotificationPage {
  modalController = inject(ModalController);
  translate = inject(TranslateService);
  private store = inject<Store<AppState>>(Store);
  private alertController = inject(AlertController);

  public pushNotifications$: Observable<PushNotificationSchema[]>;

  constructor() {
    this.pushNotifications$ = this.store.select(getPushNotificationItems);

    if(Capacitor.isNativePlatform()) {
      PushNotifications.getDeliveredNotifications().then((pushNotificationDeliveredList: DeliveredNotifications) => {
        for(const pushNotification of pushNotificationDeliveredList.notifications) {
          this.store.dispatch(AddPushNotification({ pushNotification }));
        }
        PushNotifications.removeAllDeliveredNotifications();
      }).catch((error: Error) => {
        console.warn(error.message);
      });
    }
  }

  public clearNotifications() {
    this.alertController
      .create({
        header: this.translate.instant('push-notification.confirmClear.header'),
        message: this.translate.instant('push-notification.confirmClear.message'),
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              this.store.dispatch(ClearPushNotifications());
            },
          },
          {
            text: this.translate.instant('core.cancel'),
          },
        ],
      })
      .then((alert: HTMLIonAlertElement) => {
        alert.present();
      });
  }

  public async delete(notificationId: string) {
    const alert = await this.alertController.create({
      header: this.translate.instant('push-notification.confirmRemove.header'),
      message: this.translate.instant('push-notification.confirmRemove.message'),
      buttons: [{
        text: this.translate.instant('core.delete'),
        role: 'destructive',
        handler: () => {
          this.store.dispatch(RemovePushNotification({ id: notificationId }));
        }
      }, {
        text: this.translate.instant('core.cancel'),
        role: 'cancel'
      }]
    });
    alert.present();
  }
}
